import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl } from '@angular/forms'; 
import { ActivatedRoute, Router } from '@angular/router'; 

import { ContractorService } from 'app/_services/contractor.service';
import { TokenStorageService } from 'app/_services/token-storage.service';

@Component({
  selector: 'app-edit-contractor',
  templateUrl: './edit-contractor.component.html',
})
export class EditContractorComponent implements OnInit {
  contactTypeList: any = [];
  languageList: any = [];
  referralList: any = [];
  contractorInfo: any = {};

  editContractorForm: FormGroup = new FormGroup({
    company_name: new FormControl(""),
    contact_name: new FormControl(""),
    phone: new FormControl(""),
    mobile: new FormControl(""),
    fax: new FormControl(""),
    email: new FormControl(""),
    address: new FormControl(""),
    address2: new FormControl(""),
    city: new FormControl(""),
    province: new FormControl(""),
    postalcode: new FormControl(""),
    country: new FormControl("")
  })

  clientTypeForm: FormGroup = new FormGroup({});

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private contractor: ContractorService,
  ) { }

  ngOnInit(): void {
    const contactUUID = this.tokenStorage.getToken() || "";
    const contractorid = this.activatedRoute.snapshot.params['contractorid'];

    this.contractor.getContractor$(contractorid, contactUUID).subscribe((data: any) => {
        this.contractorInfo = data;
        console.log("contractorInfo: ", this.contractorInfo)

        this.editContractorForm.setValue({
          company_name: this.contractorInfo.company_name,
          contact_name: this.contractorInfo.contact_name,
          phone: this.contractorInfo.phone,
          mobile: this.contractorInfo.mobile,
          fax: this.contractorInfo.fax,
          email: this.contractorInfo.email,
          address: this.contractorInfo.address,
          address2: this.contractorInfo.address2,
          city: this.contractorInfo.city,
          province: this.contractorInfo.province,
          postalcode: this.contractorInfo.province,
          country: this.contractorInfo.country
        });
    });
  }

  onSubmit(values: any): void {
    const contactUUID = this.tokenStorage.getToken() || "";
    const contractorid = this.activatedRoute.snapshot.params['contractorid'];

    let contractorInfo = {
      company_name: values.company_name,
      contact_name: values.contact_name,
      phone: values.phone,
      mobile: values.mobile,
      fax: values.fax,
      email: values.email,
      address: values.address,
      address2: values.address2,
      city: values.city,
      province: values.province,
      postalcode: values.postalcode,
      country: values.country,
      contractor_id: this.contractorInfo.contractor_id,
      active: this.contractorInfo.active,
      updated: this.contractorInfo.updated
    }

    console.log("contractorInfo: ", contractorInfo)

    this.contractor.updateContractor$(contactUUID, contractorInfo).subscribe({
      next: (data:any) => {
        console.log("Data --> ", data);
        this.router.navigate(['soustraitants']);
      },
      error: (err: any) => {
        console.log("Something went wrong: ", err)
      }
    })
  }
}